
import { useNavigate } from "react-router-dom";
import { useState, type ReactNode, Fragment, useEffect } from "react";

import styles from './DrawerRouterContainer.module.css';

import { CloseIcon, FlagsIcon, HomeIcon, MenuIcon, UnpinIcon, UserIcon } from "@syncfusion/react-icons";

import { Sidebar, SidebarLayout, SidebarMain, Toolbar, ToolbarItem, ToolbarSpacer, type SidebarMode } from "@syncfusion/react-navigations";
import { ListView } from "@syncfusion/react-lists";
import { Button } from "@syncfusion/react-buttons";
import { useScreenSize } from "../services/screen-size-service";

export interface DrawerRouterContainerProps {
    children: React.ReactNode;
}

interface NavigationDataItem {
    id: string;
    text: string;
    icon: ReactNode;
    route: string;
    selected?: boolean;

    [key: string]: any; 

}

export const DrawerRouterContainer = (props: DrawerRouterContainerProps) => {
    const navigate = useNavigate();

    const navigationItems: NavigationDataItem[] = [
         { id:'1',  text: 'Inicio',icon: (<HomeIcon/>), route:'', selected: true},
         { id: '3', text: 'Nacionalidades', icon:(<FlagsIcon/>), route: '/nationalities'},
         { id: '4', text: 'Continentes', icon:(<UnpinIcon/>), route: '/continents'},
         { id: '2' , text: 'Usuarios', icon: (<UserIcon/>), route:'/users'}
    ]

    const [expanded, setExpanded] = useState(false);

    function toggleSidenav(){
        setExpanded(!expanded);
    }

    function closeSidenav(){
        setExpanded(false);
    }

    function itemSelected(item: NavigationDataItem){
        navigate(item.route);
        setExpanded(false);
    }


    function listViewItemTemplate(data: NavigationDataItem){
        return (<div className="sb-sidebar-list-item sf-content-between" onClick={()=>itemSelected(data)}>{data.icon} {data.text}</div>)
    }
    const screenSize = useScreenSize(updateScreenSize);

    function updateScreenSize(s: string){
        if(s == "xs"  || s == "sm"){
            setSidebarMode("Over")
        }else{
            setSidebarMode("Push")
        }
    }
    
    const [sidebarMode, setSidebarMode] = useState<SidebarMode>('Push')

    useEffect(()=>updateScreenSize(screenSize));

    

   

    return(
        <Fragment>
            <SidebarLayout>
                <Sidebar 
                open={expanded} 
                backdrop={sidebarMode == "Over"} 
                closeOnDocumentClick={sidebarMode == "Over"}
                mode={sidebarMode}>
                    <ListView
                    className={styles.menuListview}
                    headerTemplate={
                    <Toolbar>
                        <ToolbarSpacer></ToolbarSpacer>
                        <ToolbarItem>
                            {sidebarMode == "Over" && <Button onClick={closeSidenav} icon={<CloseIcon/>}></Button>}
                        </ToolbarItem>
                    </Toolbar>}
                    fields={{id:'id', text: 'text'}}
                    dataSource={navigationItems} 
                    itemTemplate={listViewItemTemplate}/>
                </Sidebar>
                <SidebarMain>
                    <Toolbar>
                        <ToolbarItem>
                            <Button onClick={toggleSidenav} icon={<MenuIcon/>}>
                            </Button>
                        </ToolbarItem>
                    </Toolbar>
                    {props.children}
                </SidebarMain>
            </SidebarLayout>
        </Fragment>
    );

}